module.exports = __webpack_public_path__ + "static/media/box.da9170dc.svg";